import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import animationGif from "./images/animation.gif";
import mobileGif from "./images/mobile-animation.gif";
import styles from "./styles.module.scss";
import React from "react";
const TargetAnimation = ({ goNext }) => {
    const isMobile = useScreenWidth() < 968;
    useEffect(() => {
        setTimeout(() => {
            goNext();
        }, 3000);
    }, []);
    return (_jsx("div", { className: styles.animation, children: _jsx("img", { src: isMobile ? mobileGif : animationGif, alt: "" }) }));
};
export default TargetAnimation;
